import { icon } from "../assets/assets";
import AmpleHireLabelTag from "../ample-hire-html-tags/ample-hire-label-tag";
import AmpleHireInputTag from "../ample-hire-html-tags/ample-hire-input-tag";
import AmpleHireImageTag from "../ample-hire-html-tags/ample-hire-image-tag";

const SwitchInputField = ({
  switchInputFieldIdAndName = "",
  checked = false,
  onChange = () => {},
  labelText,
}) => {
  return (
    <div className="switch">
      <AmpleHireLabelTag labelText={labelText}>
        <AmpleHireInputTag
          id={switchInputFieldIdAndName}
          name={switchInputFieldIdAndName}
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
        <span className="lever">
          <i>
            <AmpleHireImageTag
              imgSrc={icon.checkMarkicon}
              alt={icon.checkMarkicon}
            />
          </i>
        </span>
      </AmpleHireLabelTag>
    </div>
  );
};

export default SwitchInputField;
